export default "__VITE_ASSET__b0e62095__"